// extracted by mini-css-extract-plugin
module.exports = {"container":"notilesetlayernotification_container__2PJGv","icon":"notilesetlayernotification_icon__2N7PK","button":"notilesetlayernotification_button__VXwzJ"};